import {Card, CardContent, Grid} from "@mui/material";
import React, {useEffect, useState} from "react";
import {GRN_DETAILS, GRN_ORDER_COLUMN} from "../../columns/columns";
import CounterCard from "../../components/CounterCard";
import {
  getGRNlineItemsByReceiptId,
  getWareHouseReciptDetails,
} from "../../services/dataService";
import GRNTable from "../../components/table/GRNTable";
import {dateBeforeMonths, today} from "../../manager/dateManager";
import {createGRNCard} from "../../manager/cardManager";
import {dispatcher, requestGRNFromStore} from "../../store/helper";
import {GOOD_RECEIVE_NOTE_LOADED} from "../../store/ActionType";
import store from "../../store/Store";
import {getUser} from "../../services/authService";
import {SUPPLIER_GRN_ORDER_COLUMN} from "../../columns/supplier-columns";

function GoodsReceivedNote() {
  const user = getUser();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [PONumber, setPONumber] = useState("");
  const [RCPTNumber, setRCPTNumber] = useState("");
  const [fromDate, setFromDate] = useState(dateBeforeMonths(4));
  const [toDate, setToDate] = useState(today());
  const [overviewItems, setOverviewItems] = useState(createGRNCard("loading"));
  

  const getGRN = async () => {
    try {
      setLoading(true);
      const response = await getWareHouseReciptDetails({
        FromDate: fromDate,
        ToDate: toDate,
        PONumber: PONumber,
        RCPTNO: RCPTNumber,
      });
      dispatcher(GOOD_RECEIVE_NOTE_LOADED, response.data);
      setOverviewItems(createGRNCard([response.data.length]));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setTableData([]);
      if (error.response && error.response.status === 404) {
        setOverviewItems(createGRNCard(404));
      } else {
        setOverviewItems(createGRNCard("error"));
      }
    }
  };

  useEffect(() => {
    const grnStoreDate = requestGRNFromStore();
    if (grnStoreDate.length === 0) {
      getGRN();
    } else {
      setTableData(grnStoreDate);
      setOverviewItems(createGRNCard([grnStoreDate.length]));
    }

    const unsubscribe = store.subscribe(() => {
      setTableData(requestGRNFromStore());
    });
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (  
    <>
      <Grid container spacing={2} marginTop={0}>
        <Grid container spacing={2}>
          {overviewItems.map((item, index) => (
            <Grid key={index} item xs={12} sm={6} md={6} lg={3}>
              <CounterCard
                description={item.unit}
                title={item.value}
                icon={item.icon}
                color={item.dark}
                bgColor={item.light}
              />
            </Grid>
          ))}
          <Grid item xs={12} md={12}>
            <Card>
              <CardContent>
                <GRNTable
                  data={tableData}
                  columns={
                    user?.globalID ||
                    user?.isSupplierOperation ||
                    user?.isSupplierFinance
                      ? SUPPLIER_GRN_ORDER_COLUMN
                      : GRN_ORDER_COLUMN
                  }
                  fromDate={fromDate}
                  toDate={toDate}
                  handleFromDate={(e) => setFromDate(e.target.value)}
                  handleToDate={(e) => setToDate(e.target.value)}
                  callAPI={getGRN}
                  PONumber={PONumber}
                  setPONumber={(e) => setPONumber(e.target.value)}
                  RCPTNumber={RCPTNumber}
                  setRCPTNumber={(e) => setRCPTNumber(e.target.value)}
                  loading={loading}
                  detailsAPI={getGRNlineItemsByReceiptId}
                  detailsColumn={GRN_DETAILS}
                  moduleName="GRN"
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default GoodsReceivedNote;
